export default "__VITE_ASSET__8d6b377f__"